import formsReducer, {
  disableForm,
  enableForm,
  clearForm,
  setFormErrors
} from "../lib/formsReducer";
import entitiesReducer from "../lib/entitiesReducer";
import * as actions from "./actions";
import { Record, Map } from "immutable";
import { isApiCall } from "../app/schema";

import Audits from "./audits";

const feature = "audits";

const InitialState = Record({
  audits: new Audits()
});

const initialState = new InitialState();

function revive() {
  return initialState.merge({});
}

export default function AuditsReducer(state = initialState, action) {
  if (!(state instanceof InitialState)) return revive(state);

  if (isApiCall(action.type)) {
    if (
      action.payload &&
        action.payload.entities &&
        action.payload.entities.audits
    ) {
      state = state.updateIn(["audits", "entities"], map =>
        map.mergeDeep(action.payload.entities.audits));
    }
  }

  switch (action.type) {
    case actions.GET_AUDITS: {
      return state.setIn(["audits", "loading"], true);
    }
    case actions.GET_AUDITS_SUCCESS: {
      state = state.deleteIn(["audits", "entities"]);
      state = state.deleteIn(["audits", "results"]);
      state = state.setIn(
        ["audits", "meta", "all"],
        action.payload.result.meta.all
      );
      state = state.setIn(
        ["audits", "meta", "count"],
        action.payload.result.meta.count
      );
      state = state.updateIn(["audits", "entities"], map =>
        map.mergeDeep(action.payload.entities.audits));
      state = state.setIn(["audits", "results"], action.payload.result.audits);
      return state.setIn(["audits", "loading"], false);
    }
    case actions.GET_AUDITS_ERROR: {
      return state.setIn(["audits", "loading"], false);
    }

    case actions.GET_AUDIT: {
      return state.setIn(["audits", "loading"], true);
    }
    case actions.GET_AUDIT_SUCCESS: {
      return state.setIn(["audits", "loading"], false);
    }
    case actions.GET_AUDIT_ERROR: {
      return state.setIn(["audits", "loading"], false);
    }

  }

  return entitiesReducer(formsReducer(state, feature, action), feature, action);
}



// WEBPACK FOOTER //
// ./src/common/audits/reducer.js